import { CurrencyCode } from 'app/library/course-offering/enums/currency-code.enum';

export interface ITenantCurrencyConfig {
    currencies: CurrencyCode[];
    defaultCurrency: CurrencyCode;
}

const FALLBACK_CURRENCIES: CurrencyCode[] = [CurrencyCode.CHF, CurrencyCode.EUR, CurrencyCode.USD];
const CURRENCY_CODES = new Set(FALLBACK_CURRENCIES);

interface ITenantCurrencyEntry {
    currency: string;
    is_default: boolean;
}

function normalizeCurrencyCode(value: unknown): CurrencyCode | null {
    if (typeof value !== 'string') {
        return null;
    }

    const normalized = value.toUpperCase();

    return CURRENCY_CODES.has(normalized as CurrencyCode) ? (normalized as CurrencyCode) : null;
}

function readRawCurrencyEntries(tenantConfig: Record<string, unknown> | null | undefined): ITenantCurrencyEntry[] {
    if (!tenantConfig) {
        return [];
    }

    const rawCurrencyConfig = tenantConfig.currency;
    if (!Array.isArray(rawCurrencyConfig)) {
        return [];
    }

    return rawCurrencyConfig as ITenantCurrencyEntry[];
}

export function getTenantCurrencyConfig(tenantConfig: Record<string, unknown> | null | undefined): ITenantCurrencyConfig {
    const entries = readRawCurrencyEntries(tenantConfig);
    const currencies = Array.from(new Set(entries.map((entry) => normalizeCurrencyCode(entry?.currency)).filter((code): code is CurrencyCode => !!code)));
    const defaultFromConfig = normalizeCurrencyCode(entries.find((entry) => !!entry?.is_default)?.currency);
    const resolvedCurrencies = currencies.length ? currencies : [...FALLBACK_CURRENCIES];
    const defaultCurrency = defaultFromConfig || resolvedCurrencies[0];

    if (!resolvedCurrencies.includes(defaultCurrency)) {
        resolvedCurrencies.unshift(defaultCurrency);
    }

    const orderedCurrencies = [defaultCurrency, ...resolvedCurrencies.filter((currency) => currency !== defaultCurrency)];

    return {
        currencies: orderedCurrencies,
        defaultCurrency,
    };
}
